export default __webpack_public_path__ + "assets/a621834b70ec0fe9faee464774ed972b.svg";